import { defineMessages } from 'react-intl-next';

export const messages: {
	timeoutTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	timeoutPrimaryText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	timeoutSecondaryText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	timeoutButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	timeoutTooltip: {
		id: 'search-page.app-filter-sidebar.product-timeout-tooltip',
		defaultMessage: '{product} results were too slow to show',
		description:
			"Tooltip text shown when timer icon is hovered, informing when a product's results take too long to load",
	},
	timeoutPrimaryText: {
		id: 'search-page.app-filter-sidebar.product-timeout-primary-text',
		defaultMessage: '{product} results took too long to show',
		description:
			"Primary text shown in popup when timer icon is clicked, informing users when a product's results took too long to show",
	},
	timeoutSecondaryText: {
		id: 'search-page.app-filter-sidebar.product-timeout-secondary-text',
		defaultMessage: 'Try again by filtering just for {product}.',
		description:
			"Secondary text shown in popup when timer icon is clicked, informing users how to try again for a product's results that took too long to show",
	},
	timeoutButtonText: {
		id: 'search-page.app-filter-sidebar.product-timeout-button-text',
		defaultMessage: 'See only {product} results',
		description:
			"Button text shown in popup when timer icon is clicked, allowing users to try again for a product's results that took too long to show",
	},
});
